import React from 'react'
import date from 'date-and-time'
import PropTypes from 'prop-types'
import Rating from '../../Rating/Rating'

const Review = ({ reviewer, time, rating, review }) => (
  <div className='review'>
    <div className='reviewer'>
      <div
        className='image'
        style={{
          background: `url(${reviewer.image}) center center /cover no-repeat`,
        }}
      />
      <div className='info'>
        <div className='name'>{reviewer.name}</div>
        <div className='date'>{date.format(new Date(time), 'DD MMM YYYY')}</div>
      </div>
    </div>
    <div className='content'>
      <Rating value={rating} />
      <p className='message'>{review}</p>
    </div>
  </div>
)

Review.propTypes = {
  reviewer: PropTypes.shape({
    name: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
  }).isRequired,
  time: PropTypes.number.isRequired,
  rating: PropTypes.number.isRequired,
  review: PropTypes.string.isRequired,
}

Review.defaultProps = {
  reviewer: {
    name: '',
    image: '',
  },
  time: new Date().getTime(),
  rating: 0,
  review: '',
}

export default Review
